{
  "newFeature": "簡化後應用程式開關，現在會以單一清單的形式顯示為您啟用的應用程式。",
  "newLayout": "新版面",
  "ok": "確定"
}
